import { z } from 'zod';

// GDPR processing basis (Rechtsgrundlage) per IMM-7. Shared across the lead
// capture surface and the contact record a qualified lead converts into, so
// the basis carries over unchanged. Defaults to PRE_CONTRACTUAL_MEASURES on
// lead capture.
export const LEGAL_BASES = [
  'CONSENT',
  'CONTRACT_INITIATION',
  'PRE_CONTRACTUAL_MEASURES',
  'LEGAL_OBLIGATION',
  'LEGITIMATE_INTEREST',
] as const;
export const LegalBasisSchema = z.enum(LEGAL_BASES);
export type LegalBasis = z.infer<typeof LegalBasisSchema>;
